import axios from '../../plugins/axios'
import { getCurrentBusinessId } from '../../utils/authUtils'

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

// Descarga robusta de un blob: fija el tipo MIME, agrega y REMUEVE el link,
// y libera el object URL. Evita que en ciertos navegadores no dispare la descarga.
const downloadBlob = (data, filename) => {
  const blob = data instanceof Blob ? data : new Blob([data], { type: XLSX_MIME })
  const typed = blob.type ? blob : new Blob([blob], { type: XLSX_MIME })
  const url = window.URL.createObjectURL(typed)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }, 0)
}

export const createCommercialProjection = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const setCommercialProjectionByProduct = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/set-by-product/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const listCommercialProjections = (_, { params } = {}) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const editCommercialProjection = (_, { id, data } = {} ) => {
  return axios.patch(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/${id}/`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

// PATCH en JSON (no multipart como editCommercialProjection, que va con
// Content-Type multipart porque también sube archivos). Guardar la estacionalidad
// dispara el recálculo del Mix Óptimo en el backend.
export const editCommercialProjectionSeasonality = (_, { id, data } = {} ) => {
  return axios.patch(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/${id}/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error, data: error.response && error.response.data }))
}

export const commercialProjectionUpdateOptimalMix = (_, { id } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/${id}/update-optimal-mix/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const deleteCommercialProjection = (_, id) => {
  return axios.delete(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/${id}/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getCommercialProjection = (_, id) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/${id}/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const createCommercialProjectionItem = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const listCommercialProjectionItems = (_, { params } = {}) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const editCommercialProjectionItem = (_, { id, data } = {} ) => {
  return axios.patch(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/${id}/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const deleteCommercialProjectionItem = (_, id) => {
  return axios.delete(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/${id}/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getCommercialProjectionItem = (_, id) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/${id}/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getProjectionMatrix = (_, { projection } = {}) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/matrix/`, { params: { projection } })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const setProjectionMatrix = (_, { data } = {}) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-item/set-matrix/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getProjectionByCutomersChart = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/chart-projection-by-customer`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getTotalProjectionChart = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/total-projection`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getTopProductsTable = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/table-projection-by-product`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getHeatMapChart = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/heatmap`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getOptimalMixByCustomerChart = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/chart-optimal-mix-by-customer`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getOptimalMixByProductChart = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/chart-optimal-mix-by-product`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getOptimalMixTable = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/table-optimal-mix`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getOptimalMixStatistics = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/statistics-optimal-mix`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getBreakEvenBase = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/break-even-base`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getCapacityUtilization = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/capacity-utilization`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getFixedCosts = () => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/fixed-cost/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const setFixedCosts = (_, { data } = {}) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/fixed-cost/bulk/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const exportOptimalMix = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/export-optimal-mix`, { params, responseType: 'blob'})
    .then(response => {
      downloadBlob(response.data, 'mix_optimo.xlsx')
      return { status: response.status }
    })
    .catch(error => ({ error }))
}

export const getSalePlanByProductChart = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/chart-sale-plan-by-product`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getSalePlanByCustomerChart = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/chart-sale-plan-by-customer`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const importSalePlan = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/import/`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const importMaster = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/import-master/`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const loadExample = () => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/load-example/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

// Descarga la plantilla del caso PRE-LLENADA con los clientes y productos del negocio.
export const downloadCaseTemplate = () => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/case-template/`, { responseType: 'blob' })
    .then(response => {
      downloadBlob(response.data, 'plantilla-caso.xlsx')
      return { status: response.status }
    })
    .catch(error => ({ error }))
}

// Sube la matriz de consumos (Potencial/Real) y crea el caso con su Mix Óptimo.
export const importCaseMatrix = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/import-case/`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error, data: error.response && error.response.data, status: error.response && error.response.status }))
}

export const getSalePlanItem = (_, id) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/${id}/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const listSalePlanItems = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const createSalePlanItem = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const editSalePlanItem = (_, { id, data } = {} ) => {
  return axios.patch(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/${id}/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const setSalePlanItemByProduct = (_, { data } = {} ) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/set-by-product/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const deleteSalePlanItem = (_, id) => {
  return axios.delete(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/${id}/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const exportSalePlan = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/export-sale-plan`, { params, responseType: 'blob'})
    .then(response => {
      downloadBlob(response.data, 'plan_ventas.xlsx')
      return { data: response.data, response, status: response.status }
    })
    .catch(error => ({ error }))
}

export const downloadOptimalMix = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/export-optimal-mix`, { params, responseType: 'blob'})
    .catch(error => ({ error }))
}

export const statisticsOptimalMix = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/statistics-optimal-mix/`, { params })
    .catch(error => ({ error }))
}

export const downloadSalePlan = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/export-sale-plan`, { params, responseType: 'blob'})
    .catch(error => ({ error }))
}

export const downloadProjectionItems = (_, id) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/${id}/export-items/`, { responseType: 'blob'})
    .catch(error => ({ error }))
}

export const createPlanSale = (_, id) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/commercial-projection/${id}/create-plan-sale/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}
export const getProjectionComparisonChart = (_) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/chart-projection-comparison`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getStatisticsOptimalMix = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-chart/statistics-optimal-mix/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getStatisticsSalePlan = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/commercial-projection-sale-plan-item/statistics-sale-plan/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}
// ---- Seguimiento comercial ----
export const getCoverage = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/seguimiento/coverage/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getFunnel = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/seguimiento/funnel/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getPlanVsReal = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/seguimiento/plan-vs-real/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const listSalesContacts = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/sales-contact/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const createSalesContact = (_, { data } = {}) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/sales-contact/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const listDeals = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/deal/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const createDeal = (_, { data } = {}) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/deal/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getSalespeople = () => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/seguimiento/salespeople/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getRealCosts = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/seguimiento/real-costs/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const setRealCosts = (_, { data } = {}) => {
  return axios.post(`/estimated/business/${getCurrentBusinessId()}/seguimiento/real-costs/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getActivity = (_, params) => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/seguimiento/activity/`, { params })
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const getSeguimientoSettings = () => {
  return axios.get(`/estimated/business/${getCurrentBusinessId()}/seguimiento/settings/`)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error }))
}

export const updateSeguimientoSettings = (_, { data } = {}) => {
  return axios.put(`/estimated/business/${getCurrentBusinessId()}/seguimiento/settings/`, data)
    .then(response => ({ data: response.data, response, status: response.status }))
    .catch(error => ({ error: error.response }))
}
